import * as React from "react"
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import { defPath } from '../config/defPath'

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/navigation";
import { Grid, Navigation } from "swiper";
import Avatar from "../views/sensei3D"
import { page } from "../pages/sensei3D"

import { CSSTransition } from 'react-transition-group';

const BLOGS_LIST_URL = `${window.origin}/aguila/loyalty/helps`
const SEARCH_URL = `${window.origin}/aguila/loyalty/helps/search`

function App() {
  const [blogList, setBlogList] = React.useState<any[]>([]);
  const [isOpenPopup, setIsOpenPopup] = React.useState<boolean>(false);
  const swiperRef = React.useRef<any>(null)
  const nodeRef = React.useRef<any>(null)

  function truncate(str: string, maxlength: number) {
    return (str.length > maxlength) ?
      str.slice(0, maxlength - 1) + '…' : str;
  }

  React.useEffect(() => {
    getCardsList()
    page()
  }, [])

  React.useEffect(() => {
    const cards = document.querySelectorAll(".guia_sliderBlogs .swiper-slide h2 p")
    if (cards.length > 0) {
      cards.forEach((card: any) => {
        card.textContent = truncate(card.textContent, 27)
      })
    }
  }, [blogList])

  const getCardsList = async () => {
    const res = await fetch(BLOGS_LIST_URL, {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
    })
    const data = await res.json()
    data && setBlogList(data)
  }

  const searchList = async (e: any) => {
    let payload = { words: e?.target.value }
    if (e?.target.value) {
      const res = await fetch(SEARCH_URL, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      const data = await res.json()
      if (data.message === "No se encontró ayuda relacionada") {
        setBlogList([])
        return
      }
      data && setBlogList(data)
    }
  }

  const handleClickPopup = (index: any) => {
    setIsOpenPopup(true)
    const popUp = document.querySelector(".guia_modal")
    popUp?.classList.add("open")

    if (swiperRef.current) {
      swiperRef.current.swiper.slideTo(index);
    }
  }


  return (
    // <section  className={`${isOpenPopup ? 'openPopup' : ''} guia`}>
    <section id="king-home" className={`${isOpenPopup ? 'openPopup' : ''} guia`}>
      <NewHeader />
      <Modal />
      <BlogModal swiperRef={swiperRef} blogList={blogList} setIsOpenPopup={setIsOpenPopup} />

      <div className="guia_header">
        <h1 className="guia_header--title ar__title">Ayuda</h1>
        <p className="guia_header--text medium_45">con @rubigol</p>
      </div>

      <Avatar />
      <div className="guia_content">
        <div className="guia_avatar">
          <div className="guia_avatar--textBox">
            <h1 className="guia_avatar--title ar__title">Pregúntale</h1>
            <p className="guia_avatar--text medium_45">a @Rubigol</p>
          </div>
        </div>
        <div className="guia_sliderBlogs">
          {blogList.length > 0 &&
            <Swiper
              slidesPerView={1.2}
              spaceBetween={18}
              grid={{
                rows: 2,
                fill: 'row'
              }}
              observer={true}
              breakpoints={{
                640: {
                  spaceBetween: 20,
                },
                867: {
                  slidesPerView: "auto",
                  spaceBetween: 20,
                },
                1200: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                1440: {
                  spaceBetween: 30,
                },
              }}
              navigation={{
                nextEl: '.guia_search--wrapper .swiper-button-custom.swiper-button-next',
                prevEl: '.guia_search--wrapper .swiper-button-custom.swiper-button-prev',
              }}
              modules={[Grid, Navigation]}>
              {
                blogList.map((blog, index) => (
                  <SwiperSlide key={blog.id} onClick={() => handleClickPopup(index)}>
                    <picture>
                      <source type="image/webp" srcSet={`${window.origin}${blog.img_preview.imgurl_webp}`} />
                      <img src={`${window.origin}${blog.img_preview.imgurl_raw}`} alt={`${blog.img_preview.img_alt}`} />
                    </picture>
                    <div className="guia_card--textBox">
                      <h2 className="black_30" dangerouslySetInnerHTML={{ __html: blog.titulo }}></h2>
                    </div>
                  </SwiperSlide>
                ))
              }
            </Swiper>
          }
        </div>
      </div>

      <div className="guia_search--wrapper">
        <div className="guia_search">
          <div className="guia_search--box">
            <span className="guia_search--text">Buscar</span>
            <input className="guia_search--input" type="text" placeholder="Como subo en el ranking..." onChange={(e) => searchList(e)} />
            <div className="guia_search--icon"></div>
          </div>
        </div>
        <div className="swiper-button-custom swiper-button-next"></div>
        <div className="swiper-button-custom swiper-button-prev"></div>
      </div>
    </section>
  )
}

const BlogModal = ({ blogList, swiperRef, setIsOpenPopup }: any) => {
  const handleClosePopup = () => {
    const popUp = document.querySelector(".guia_modal")
    popUp?.classList.remove("open")
    setIsOpenPopup(false)
  }

  return (
    <>
      <div className="guia_modal">
        <div className="guia_modal--header">
          <div className="guia_modal--header-imgBox">
            <img src={`${defPath}/assets/images/newHeaderTopLogos/ola.png`} loading="lazy" alt="Imagen olas" />
            <img src={`${defPath}/assets/images/newHeaderTopLogos/ola.png`} loading="lazy" alt="Imagen olas" />
          </div>

          <a href="/" className="logoAguila">
            <img src={`${defPath}/assets/images/logo_aguila_new.png`} loading="lazy" alt="Logo Estadio Aguila" />
          </a>

          <div className="guia_modal--header-icon" onClick={handleClosePopup}></div>
        </div>
        <Swiper
          ref={swiperRef}
          slidesPerView={1}
          observer={true}
          navigation={{
            nextEl: '.swiper-button-popUpcustom.swiper-button-next',
            prevEl: '.swiper-button-popUpcustom.swiper-button-prev',
          }}
          modules={[Navigation]}>
          {
            blogList.map((blog: any) => (
              <SwiperSlide key={blog.id}>
                {<div className="guia_modal--wrapper">
                  <div className="guia_modal--title title_2" dangerouslySetInnerHTML={{ __html: blog.titulo }}></div>
                  <div className="guia_modal--imgBox">
                    <picture>
                      <source type="image/webp" media="(min-width: 991px)" srcSet={`${window.origin}${blog.img_interna_desk.imgurl_webp}`} />
                      <source media="(min-width: 991px)" srcSet={`${window.origin}${blog.img_interna_desk.imgurl_webp}`} />
                      <source type="image/webp" srcSet={`${window.origin}${blog.img_interna_mob.imgurl_webp}`} />
                      <img src={`${window.origin}${blog.img_interna_mob.imgurl_raw}`} alt={blog.img_interna_mob.img_alt} />
                    </picture>
                  </div>

                  <div className="guia_modal--textBox" dangerouslySetInnerHTML={{ __html: blog.descripcion }}></div>
                  <div className="guia_modal--btnBox">
                    <a className="ar__btn-primary" href={blog.boton.uri}>{blog.boton.title}</a>
                  </div>
                </div>}
              </SwiperSlide>
            ))
          }
          <div className="swiper-button-popUpcustom swiper-button-next"></div>
          <div className="swiper-button-popUpcustom swiper-button-prev"></div>
        </Swiper>
      </div>
    </>
  )
}

export default App